import { Badge } from "@/src/components/design-system/Badge/Badge";

export function InternalFeatureBadge() {
  return <Badge color="orangeTint" text="Internal" />;
}
